import styles from '../../css/admin/StatusMessage.module.css';
import { useLanguage } from '../../hooks/LanguageContext'; // Import useLanguage hook
import translations from '../admin/translations'; // 번역 객체 가져오기

export default function StatusMessage({ errorCode, situation, status, desc }) {
  const { language } = useLanguage(); // Use language state
  const t = translations[language]; // Translations short-hand
  const renderStatusMessage = () => {
    if (situation === 'gift') {
      if (status === 'success') {
        return (
          <div className={styles.messageContainer}>
            <img
              className={styles.statusIcon}
              src="/icons/success.png"
              alt="success"
            />
            <div className={styles.message}>
              <span className={`${styles.alert} ${styles.success}`}>
                {t.giftSendSuccess}
              </span>
              <span className={`${styles.explanation} ${styles.success}`}>
                {t.checkSentGift}
              </span>
            </div>
          </div>
        );
      } else if (status === 'failure') {
        return (
          <div className={styles.messageContainer}>
            <img
              className={styles.statusIcon}
              src="/icons/failure.png"
              alt="failure"
            />
            <div className={styles.message}>
              <span className={`${styles.alert} ${styles.failure}`}>
                {t.giftSendFailure}
              </span>
              <span className={`${styles.explanation} ${styles.failure}`}>
                ({t.reason} {t.paymentError})
              </span>
            </div>
          </div>
        );
      }
    } else if (situation === 'verification') {
      if (status === 'success') {
        return (
          <div className={styles.messageContainer}>
            <img
              className={`${styles.statusIcon} ${styles.verificationSuccessIcon}`}
              src="/icons/success.png"
              alt="success"
            />
            <div className={styles.message}>
              <span
                className={`${styles.alert} ${styles.verificationSuccessAlert} ${styles.success}`}
              >
                {t.giftVerificationSuccess}
              </span>
            </div>
          </div>
        );
      } else if (status === 'failure') {
        return (
          <div className={styles.messageContainer}>
            <img
              className={styles.statusIcon}
              src="/icons/failure.png"
              alt="failure"
            />
            <div className={styles.message}>
              <span className={`${styles.alert} ${styles.failure}`}>
                {t.giftVerificationFailure}
              </span>
              <span className={`${styles.explanation} ${styles.failure}`}>
                ({t.verificationReason} {desc})
              </span>
            </div>
          </div>
        );
      }
    } else if (situation === 'couponVerification') {
      if (status === 'success') {
        return (
          <div className={styles.messageContainer}>
            <img
              className={styles.statusIcon}
              src="/icons/success.png"
              alt="success"
            />
            <div className={styles.message}>
              <span className={`${styles.alert} ${styles.success}`}>
                {t.couponVerificationSuccess}
              </span>
              {desc && (
                <span className={`${styles.explanation} ${styles.success}`}>
                  {desc}
                </span>
              )}
            </div>
          </div>
        );
      } else if (status === 'failure') {
        return (
          <div className={styles.messageContainer}>
            <img
              className={styles.statusIcon}
              src="/icons/failure.png"
              alt="failure"
            />
            <div className={styles.message}>
              <span className={`${styles.alert} ${styles.failure}`}>
                {t.couponVerificationFailure}
              </span>
              <span className={`${styles.explanation} ${styles.failure}`}>
                ({t.verificationReason} {desc})
              </span>
            </div>
          </div>
        );
      }
    } else if (situation === 'claim') {
      if (status === 'success') {
        return (
          <div className={styles.messageContainer}>
            <img
              className={styles.statusIcon}
              src="/icons/success.png"
              alt="success"
            />
            <div className={styles.message}>
              <span className={`${styles.alert} ${styles.success}`}>
                {t.giftClaimSuccess}
              </span>
              <span className={`${styles.explanation} ${styles.success}`}>
                {t.checkReceivedGift}
              </span>
            </div>
          </div>
        );
      } else if (status === 'failure') {
        return (
          <div className={styles.messageContainer}>
            <img
              className={styles.statusIcon}
              src="/icons/failure.png"
              alt="failure"
            />
            <div className={styles.message}>
              <span className={`${styles.alert} ${styles.failure}`}>
                {t.giftClaimFailure}
              </span>
              <span className={`${styles.explanation} ${styles.failure}`}>
                {errorCode === 409
                  ? '중복된 선물받기 요청입니다'
                  : errorCode === 404
                    ? '잘못된 링크 URL입니다'
                    : `(${t.claimReason} ${t.expiredValidity})`}
              </span>
            </div>
          </div>
        );
      }
    }
  };

  return renderStatusMessage();
}
